import { makeObservable, observable, action } from 'mobx';
import { Subject } from 'rxjs';
import { NodeBaseDto, NodeType } from '../../types';
import { WorksheetModel, InputBaseModel } from '..';
import { SourceModelBase } from '../../../custom_shared/models';

export default abstract class NodeBaseModel {
    readonly id: string;

    readonly type: NodeType;

    readonly inputValueChangeSubject = new Subject<InputBaseModel>();

    readonly inputValidationSubject = new Subject<InputBaseModel>();

    childNodes: NodeBaseModel[] = [];

    expanded: boolean = true;

    constructor(
        data: NodeBaseDto,
        readonly worksheet: WorksheetModel,
        readonly parentNode?: NodeBaseModel
    ) {
        this.id = data.id;
        this.type = data.type;

        makeObservable(this, {
            childNodes: observable,
            expanded: observable,
            setChildNodes: action,
            setExpanded: action.bound,
            toggleExpanded: action.bound
        });
    }

    setChildNodes(childNodes: NodeBaseModel[]) {
        this.childNodes = childNodes;
    }

    setExpanded(expanded: boolean) {
        this.expanded = expanded;
    }

    toggleExpanded() {
        this.setExpanded(!this.expanded);
    }

    getInputById(id: string) {
        return this.inputs.find(input => input.id === id);
    }

    getInputByGuid(guid: string) {
        return this.inputs.find(input => input.guid === guid);
    }

    get worksheetId() {
        return this.worksheet.id;
    }

    abstract update(data: NodeBaseDto, sources: SourceModelBase[]): void;

    abstract get name(): string | undefined;

    abstract get inputs(): InputBaseModel[];

    abstract get dto(): NodeBaseDto;
}
